export default "__VITE_ASSET__D7DD4fA7__"